import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./card.css";

const CardItems = ({ title, description, image, reverse }) => {
  const ref = useRef(null);

  // Scroll tracking
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });

  // Parallax image movement
  const y = useTransform(scrollYProgress, [0, 1], [-50, 50]);

  return (
    <motion.div
      ref={ref}
      className={`cardContainer ${reverse ? "reverse" : ""}`}
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <motion.div className="imgContainer" style={{ y }}>
        <img src={image} alt={title} />
      </motion.div>

      <motion.div
        className="detailContainer"
        initial={{ opacity: 0, x: reverse ? 100 : -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h3 className="cardTitle">{title}</h3>
        <p className="cardDescription">{description}</p>
      </motion.div>
    </motion.div>
  );
};

export default CardItems;